import type { AssessmentModelResource } from "api/generated";
import type { PortfolioAssessmentModel } from "portfolio/types";

export const assessmentModelFromDto = (
  dto: AssessmentModelResource,
): PortfolioAssessmentModel => ({
  value: dto.value,
  label: dto.label,
});
